module.exports = __webpack_public_path__ + "static/media/logo_cvale_fidelidade_header.95905dbb.png";